import { Reducer } from 'react';

export interface SearchState {
  searchInput: string;
  searchResults: any[];
  isLoading: boolean;
  searchError: string | null;
}
export type SearchAction =
  | { type: 'SET_SEARCH_INPUT'; payload: string }
  | { type: 'SET_SEARCH_RESULTS'; payload: any[] }
  | { type: 'SET_LOADING'; payload: boolean }
  | { type: 'SET_ERROR'; payload: string | null }
  | { type: 'CLEAR_SEARCH' }
  | { type: 'SEARCH_START'; payload: string }
  | { type: 'SEARCH_SUCCESS'; payload: any[] }
  | { type: 'SEARCH_FAILURE'; payload: string }
  | {
      type: 'RESET_SEARCH_RESULTS';
    }
  | {
      type: 'UPDATE_SEARCH_STATE';
      payload: {
        results?: any[];
        loading?: boolean;
        error?: string | null;
        input?: string;
      };
    };

export const initialSearchState: SearchState = {
  searchInput: '',
  searchResults: [],
  isLoading: false,
  searchError: null,
};

export const searchReducer: Reducer<SearchState, SearchAction> = (state, action) => {
  switch (action.type) {
    case 'SET_SEARCH_INPUT':
      return { ...state, searchInput: action.payload };
    case 'SET_SEARCH_RESULTS':
      return { ...state, searchResults: action.payload };
    case 'SET_LOADING':
      return { ...state, isLoading: action.payload };
    case 'SET_ERROR':
      return { ...state, searchError: action.payload };
    case 'CLEAR_SEARCH':
      return initialSearchState;
    case 'SEARCH_START':
      return {
        ...state,
        searchInput: action.payload,
        isLoading: true,
        searchError: null,
      };
    case 'SEARCH_SUCCESS':
      return {
        ...state,
        searchResults: action.payload,
        isLoading: false,
      };
    case 'SEARCH_FAILURE':
      return {
        ...state,
        searchResults: [],
        isLoading: false,
        searchError: action.payload,
      };
    case 'RESET_SEARCH_RESULTS':
      return {
        ...state,
        searchResults: [],
        isLoading: false,
        searchError: null,
      };
    case 'UPDATE_SEARCH_STATE':
      return {
        ...state,
        searchResults:
          action.payload.results !== undefined ? action.payload.results : state.searchResults,
        isLoading: action.payload.loading !== undefined ? action.payload.loading : state.isLoading,
        searchError: action.payload.error !== undefined ? action.payload.error : state.searchError,
        searchInput: action.payload.input !== undefined ? action.payload.input : state.searchInput,
      };
    default:
      return state;
  }
};
